module.exports = "/images/avatar-s-8.jpg?6f2c7e85fa577e22b651023735b4d6a6";